import { render, staticRenderFns } from "./ItemForm2.vue?vue&type=template&id=2ef57874"
import script from "./ItemForm2.vue?vue&type=script&lang=js"
export * from "./ItemForm2.vue?vue&type=script&lang=js"
import style0 from "./ItemForm2.vue?vue&type=style&index=0&id=2ef57874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports